export default __webpack_public_path__ + "static/media/drive_file_move-white-18dp.38a47056.svg";